import { useQuery } from "react-query";
import { AxiosResponse } from "axios";
import { AppDispatch } from "../../store/store";
import { useDispatch } from "react-redux";
import { api } from "@data-phone/react-resource-server-auth";
import qs from "qs";
import { User } from "../../interfaces/user.type";
import { setAllUsersSlice } from "../../store/slices/users.slice";
import { setSmsDidsUsers } from "../../store/slices/didUsers.slice";

export interface AccountUser {
  id: string;
  account_id: string;
  email: string;
  first_name: string;
  last_name: string;
  created_at: string;
  updated_at: string;
  disabled_at: string | null;
  confirmed_at: string | null;
}

const fetchUsers = async (
  dids: string[] | undefined,
  dispatch: AppDispatch
): Promise<User[]> => {
  const query = qs.stringify({ dids: dids }, {arrayFormat: 'brackets'});
  const response: AxiosResponse<User[]> = await
    api.get(
      `${process.env.REACT_APP_SMS_API_URL}/users/did/?${query}`,
    );
  if (response.status !== 200) {
    throw new Error("Failed to fetch users");
  }
  if (response.data.length === 0) {
    dispatch(setSmsDidsUsers([]));
    return [];
  }
  dispatch(setSmsDidsUsers(response.data));
  return response.data;
};


const fetchAllUsers = async (
) => {
  const response: AxiosResponse<AccountUser[]> = await api.get(
    `${process.env.REACT_APP_AUTH_API}/api/users`,
  );
  return response.data;
}


export const useGetAllUsers = () => {
  const dispatch: AppDispatch = useDispatch();
  return useQuery("usersByAccount", () => fetchAllUsers(), {
    enabled: false,
    onError: (error) => {
      console.log(error);
    },
    onSuccess(data) {
      dispatch(setAllUsersSlice(data))
    },
  });
}




export const useGetUsersByDids = (dids: string[]) => {
  const dispatch: AppDispatch = useDispatch();
  return useQuery<any, Error>(
    "usersByDid",
    () => fetchUsers(dids, dispatch),
    {
      enabled: false,
      onError: (error) => {
        console.log(error);
      },
    }
  );
};
